import { localStorageUtil } from '../../utils/local-storage.util';

export interface SubscriptionOfferStoreValue {
  planType: string;
  slug: string;
}

export const subscriptionOfferStore =
  localStorageUtil<SubscriptionOfferStoreValue>('subscriptionOffer');
